import React, { useState,useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Download, Printer, Type } from 'lucide-react';
import { Button } from '../components/ui/button';
import myPdf from '../images/filingdetails.pdf'; // ✅ FIXED relative path
import { Footer } from '../components/Footer';
import { CompactHeader } from '../components/CompactHeader';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../components/ui/table';
import { Badge } from '../components/ui/badge';
import * as Constants from '../../constants';
import BackLoader from '../../components/backloader';

export default function OnlineSearchResultsPage() {
  const [searchParams] = useSearchParams();
  const [textSize, setTextSize] = useState('normal');
  const searchQuery = searchParams.get('q') || '';
  const [loading,setLoading] = useState(false);
  const [results,setResults] =useState(null);

  const handleDownload = () => {
    window.open(myPdf, '_blank');
  };

  const handlePrint = () => {
    window.print();
  };

  const adjustTextSize = (size) => {
    setTextSize(size);
  };


          useEffect(() => {
  
               if(searchQuery!=null){
                  onPublicSearch();
               }
              
          }, [searchQuery]);
            const onPublicSearch=async()=>{
            //this to continue the process for cases that looks like it
            setLoading(true);
              const sear={caseTitle: searchQuery,caseprocess: "all",filingtype: "all"}
            try {
            
              const resp = await fetch(`${Constants.apiUrl}/report/public-cases/0/5`, {
                method: 'POST',
                body: JSON.stringify(sear),
                headers: {
                  'Content-Type': 'application/json, text/plain',
                },
              });
              
              const data = await resp.json();
              setLoading(false);
              console.log(data);
              if (data.code === 0) {
                setResults(data.items);
              }
            } catch (error) {
              setLoading(false);
              console.error(error);
              // setErr(Constants.serverErr);
              // onMove();
            }
          }
  const getFontSizeClass = () => {
    if (textSize === 'large') return 'text-lg';
    if (textSize === 'small') return 'text-sm';
    return 'text-base';
  };

  const mockResults= [
    {
      id: '1',
      caseNumber: 'REF689432022',
      parties: 'ID/18644C/2022',
      court: 'THE STATE OF LAGOS VS RITA THELMA WILLIAMS & 2 ORS',
      judge: 'Filing of information from Min. of Justice, EFCC,etc',
      date: 'Scheduled By Trial Judge',
      status: 'Olatunde Oshodi',
    },
  ];

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      <CompactHeader  />
      {/* Accessibility Controls */}
      <div className="bg-[#1E293B] text-white py-3 px-4 sticky top-[100px] z-40">
        <div className="max-w-7xl mx-auto flex justify-end items-center">
          <Type className="w-5 h-5" aria-hidden="true" />
          <div className="flex gap-2 ml-3">
            {['small', 'normal', 'large'].map((size) => (
              <button
                key={size}
                onClick={() => adjustTextSize(size)}
                className={`px-3 py-2 rounded-lg ${
                  textSize === size ? 'bg-white text-[#1E293B]' : 'bg-white/10 hover:bg-white/20'
                }`}
              >
                {size === 'small' ? 'A-' : size === 'normal' ? 'A' : 'A+'}
              </button>
            ))}
          </div>
        </div>
      </div>
            
      {/* Header */}
      <section className="relative py-24 bg-hero-light-image dark:bg-hero-dark overflow-hidden">
        <div className="absolute inset-0 bg-black/10" />

{results!=null && <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center mb-6">
            <h1 className={`${getFontSizeClass()} text-gray-900 drop-shadow-sm mb-3`}>
              Online Search Results
            </h1>
            <p className={`${getFontSizeClass()} text-gray-800 drop-shadow-sm`}>
              Showing results for: <span className="font-semibold">"{searchQuery}"</span>
            </p>
            <p className={`${getFontSizeClass()} text-gray-700 mt-2`}>
              {results?.length} case(s) found
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-center gap-4 flex-wrap">
            <Button
              onClick={handlePrint}
              variant="outline"
              className="bg-white/90 hover:bg-white border-2 border-[#155dfc]/30 text-gray-900"
            >
              <Printer className="w-4 h-4 mr-2" /> Print Results
            </Button>
            <Button
              onClick={handleDownload}
              variant="outline"
              className="bg-white/90 hover:bg-white border-2 border-[#155dfc]/30 text-gray-900"
            >
              <Download className="w-4 h-4 mr-2" /> Download PDF
            </Button>
          </div>
        </div>}
        
      </section>

      {/* Results Table */}
      <section className="py-12 px-4 bg-white dark:bg-slate-900">
        <div className="max-w-7xl mx-auto">
          <div className="bg-white dark:bg-slate-800 rounded-xl shadow-lg border border-gray-200 dark:border-slate-700 overflow-hidden">
            <div className="overflow-x-auto">
              <Table className="table-fixed w-full">
                <TableHeader>
                  <TableRow className="bg-[#155dfc] hover:bg-[#155dfc]">
                    <TableHead className={`${getFontSizeClass()}`}>TEMP SUIT NO</TableHead>
                    <TableHead className={`${getFontSizeClass()}`}>SUIT NO</TableHead>
                    <TableHead className={`${getFontSizeClass()}`}>PARTIES TO THE CASE</TableHead>
                    <TableHead className={`${getFontSizeClass()}`}>CASE CATEGORY</TableHead>
                    <TableHead className={`${getFontSizeClass()}`}>CASE STATUS</TableHead>
                    <TableHead className={`${getFontSizeClass()}`}>JUDGE NAME</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {results?.map((caseItem, index) => (
                    <TableRow
                      key={caseItem.id}
                      className={`${
                        index % 2 === 0
                          ? 'bg-gray-50 dark:bg-slate-700'
                          : 'bg-white dark:bg-slate-800'
                      } hover:bg-blue-50 dark:hover:bg-slate-600 transition-colors`}
                    >
                      <TableCell className="font-medium text-[#155dfc]">{caseItem.referenceNumber}</TableCell>
                      <TableCell>{caseItem.caseNumber}</TableCell>
                      <TableCell>{caseItem.caseTitle}</TableCell>
                      <TableCell>{caseItem.caseCategoryTitle}</TableCell>
                      <TableCell>{caseItem.caseStatusTitle}</TableCell>
                      <TableCell>
                        <Badge className="bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                          {caseItem.judgeName??'N/A'}
                        </Badge>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </div>

          {results?.length === 0 && (
            <div className="text-center py-16">
              <div className="bg-gray-50 dark:bg-slate-800 rounded-xl p-12 border-2 border-gray-200 dark:border-slate-700">
                <h3 className={`${getFontSizeClass()} text-gray-900 dark:text-white mb-4`}>
                  No Results Found
                </h3>
                <p className={`${getFontSizeClass()} text-gray-600 dark:text-gray-400 mb-6`}>
                  No matches found for "{searchQuery}".
                </p>
                <Link to="/online-search">
                  <Button className="bg-[#155dfc] hover:bg-[#6B1515]">Return to Search</Button>
                </Link>
              </div>
            </div>
          )}
        </div>
      </section>
       <Footer />
       <BackLoader open={loading} />
    </div>
  );
}
